<template>
    <div class="interiorzone">
      <div class="toptitbox">
        <h2 class="subheading">微众银行利率更新</h2>
        
        <div  class="upload-demos">
           <el-upload
            class="upload-demo"
            action="https://oaapi.dianpiaobao.com/auth/wzInfoExcel"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="10"
            :on-exceed="handleExceed"
            :file-list="fileList">
            <input id="filename" disabled =“disabled” placeholder="请选择文件，只能上传xlsx格式的文件">
            <el-button size="small" type="primary">点击上传</el-button>
            
          </el-upload>
        </div> 
      </div>
    </div>
</template>
<script>   
  export default {
    data(){
      return{
        fileList:[],
        fileData:"",
        inp:""
      }
    },
    
    methods: {  
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },

      // request(){
        
      //     this.ajax.post('/auth/wzInfoExcel',{bizContent: {file:this.fileData}})
      //     .then(resolve => {
      //       if(result.data.status=='0000'){
      //         swal({
      //           text: '上传成功！~',
      //           buttons: false,
      //           icon:'success',
      //           timer: 2000,
      //         })
      //         this.readlist()
      //       }
      //       else{
      //         swal({
      //           text: result.data.message,
      //           buttons: false,
      //           timer: 2000
      //         })
      //       }

      //       //console.log(resolve);
          
          // })
          // .catch(
          // resolve => {
          //   console.log(resolve);
          //   },
          // );


      
 
    }
  } 
</script>
<style scoped>

.upload-demos{
  width: 520px;
  border: 1px solid #eee;
  padding: 5px 10px;
  border-radius: 10px;
}
.toptitbox>>> .el-upload  {
  width: 500px;
   /* border: 1px solid #eee; */
   padding: 5px 10px;
   border-radius: 10px;
}
#filename{
  width: 415px;
}
.shang{
  width: 80px;
  height: 30px;
  background-color: #eee;
  border-radius: 5px;

}

</style>>



// WEBPACK FOOTER //
// src/page/bankacceptance/webankintrupdate.vue